'use client';
import React from 'react';

import { CTAccordion } from './components';
import { faqSectionData } from './data';

const FaqSection = () => {
  return (
    <div className={'bg-white pb-10'}>
      <div
        id='FAQ'
        className='mx-auto max-w-7xl px-4 py-1 sm:px-6 sm:py-10 md:py-16'
      >
        <h1 className='mt-10 text-center text-xl font-extrabold text-[#333333] md:text-2xl lg:mt-0 lg:text-center lg:text-[32px] xl:text-5xl'>
          {faqSectionData.title}
        </h1>
        <div className='mt-0 py-6'>
          {faqSectionData.faqs.map((faq, index) => (
            <CTAccordion key={index} title={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
